// ‼️ import notifications styles after core package styles
import '@mantine/core/styles.css';
import '@mantine/notifications/styles.css';
import * as mantineCore from '@mantine/core';
import * as mantineSnackbars from '@mantine/notifications';
import emotionWeb from '@emotion/styled';
import { setDeps } from '@epihub/web/src/_ctx/deps';

setDeps({
  emotion: emotionWeb,
  snackbars: mantineSnackbars,
  mantine: mantineCore,
});
